const base = `//www.dreamchimney.com/api`;

export const urlChimsList = base + "/tracks/chimneys";
export const urlProfileEditRead = base + "/tracks/chim";
export const urlProfileEditWrite = base + "/tracks/chim/save";
export const urlProfileTopTenSave = base + "/tracks/chim/save/topten";
export const urlProfileLinksSave = base + "/tracks/profile/links";
export const urlProfileContactSend = base + "/tracks/contact";

// export const getChims = axios => axios.get(`${urlChims}`);
export const getChimsList = (axios) => axios.get(`${urlChimsList}`);
export const getChimProfileEdit = (axios, payload) => axios.post(`${urlProfileEditRead}`, payload);
export const getChimProfileSave = (axios, payload) =>
  axios.post(`${urlProfileEditWrite}`, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
export const getChimTopTenSave = (axios, payload) => axios.post(`${urlProfileTopTenSave}`, payload);
export const getChimLinksSave = (axios, payload) => axios.post(`${urlProfileLinksSave}`, payload);
export const getProfileContact = (axios, payload) => axios.post(`${urlProfileContactSend}`, payload);
